/**
 * Quick Add to Cart — AJAX handler for the collection-grid quick-add buttons
 * (snippets/product-card-grid.liquid). Self-contained: does not depend on
 * any other theme JS. Reuses the theme's existing cart-popup markup
 * (snippets/cart-popup.liquid) so the popup matches the site's own styling.
 */
(function () {
  'use strict';

  function qs(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function showCartPopup(item) {
    var wrapper = document.querySelector('[data-cart-popup-wrapper]');
    if (!wrapper) return false;

    var titleEl = qs(wrapper, '[data-cart-popup-title]');
    if (titleEl) titleEl.textContent = item.product_title || item.title || '';

    var qtyEl = qs(wrapper, '[data-cart-popup-quantity]');
    if (qtyEl) qtyEl.textContent = item.quantity;

    var detailsEl = qs(wrapper, '[data-cart-popup-product-details]');
    if (detailsEl) {
      detailsEl.innerHTML = '';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        var variantLi = document.createElement('li');
        variantLi.textContent = item.variant_title;
        detailsEl.appendChild(variantLi);
      }
      var priceLi = document.createElement('li');
      var amount = (item.final_line_price / 100).toFixed(2);
      priceLi.textContent = '$' + amount;
      detailsEl.appendChild(priceLi);
    }

    var imgWrapper = qs(wrapper, '[data-cart-popup-image-wrapper]');
    if (imgWrapper) {
      imgWrapper.innerHTML = '';
      if (item.image) {
        var img = document.createElement('img');
        img.className = 'cart-popup-item__image';
        img.src = item.image;
        img.alt = item.product_title || '';
        imgWrapper.appendChild(img);
        imgWrapper.classList.remove('hide');
      } else {
        imgWrapper.classList.add('hide');
      }
    }

    wrapper.classList.remove('cart-popup-wrapper--hidden', 'critical-hidden');

    updateCartCount();

    return true;
  }

  function hideCartPopup() {
    var wrapper = document.querySelector('[data-cart-popup-wrapper]');
    if (wrapper) wrapper.classList.add('cart-popup-wrapper--hidden');
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-popup-cart-quantity]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        var bubble = document.querySelector('[data-cart-count-bubble]');
        if (bubble) {
          bubble.classList.remove('critical-hidden');
          if (cart.item_count > 0) {
            bubble.classList.remove('hide');
          } else {
            bubble.classList.add('hide');
          }
        }
      })
      .catch(function () {
        /* non-fatal: cart count just won't refresh */
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('product-card__quick-add-form')) return;

    e.preventDefault();

    var submitBtn = qs(form, '[data-add-to-cart]');
    var loader = qs(form, '[data-loader]');
    if (submitBtn) submitBtn.setAttribute('aria-disabled', 'true');
    if (loader) loader.classList.remove('hide');

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.status) {
          // Shopify error response shape: { status, message, description }
          window.location.href = '/cart';
          return;
        }
        var shown = showCartPopup(data);
        if (!shown) {
          window.location.href = '/cart';
        }
      })
      .catch(function () {
        // Network/JS failure: fall back to a real (non-AJAX) form submit
        // so the add-to-cart still works, just without the popup.
        HTMLFormElement.prototype.submit.call(form);
      })
      .finally(function () {
        if (submitBtn) submitBtn.removeAttribute('aria-disabled');
        if (loader) loader.classList.add('hide');
      });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-cart-popup-close]')) {
      hideCartPopup();
    }
    if (e.target.closest && e.target.closest('[data-cart-popup-dismiss]')) {
      hideCartPopup();
    }
  });
})();
